export const SET_PHYSICAL_PEOPLE = "PHYSICAL_PEOPLE/SET_PHYSICAL_PEOPLE";
export const SET_PHYSICAL_PERSON = "PHYSICAL_PEOPLE/SET_PHYSICAL_PERSON";
export const SET_PAGINATION = "PHYSICAL_PEOPLE/SET_PAGINATION";
